export function parseNumberParam(param: string | null): number | null {
    const n = Number(param);
    return !isNaN(n) ? n : null;
}
